// @flow
import { css } from "styled-components"

const getTheme = (props: Object) => {
  if (props.secondary) return css`
      color: ${props.theme.color.primaryAccent};
      border-color: ${props.theme.color.primaryAccent};

      &:active,
      &:hover {
        ${props => !props.disabled &&
    css`
            border-color: ${props.theme.color.primaryAccentDark};
            color: ${props.theme.color.primaryAccentDark};
          `}
      }
    `;
  
  return css`
    background-color: ${props.theme.color.primaryAccent};
    border-color: ${props.theme.color.primaryAccent};
    color: ${props.theme.color.white};

    &:active,
    &:hover {
      ${props => !props.disabled &&
    css`
          background-color: ${props.theme.color.primaryAccentDark};
          border-color: ${props.theme.color.primaryAccentDark};
        `}
    }
    &:focus {
      color: ${props.theme.color.white};
    }
  `;
}

export default getTheme



// WEBPACK FOOTER //
// ./src/components/Button/styled/theme.js